// @flow
import React, {useEffect} from 'react';
import type {Node} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {NotFound} from 'components/NotFound';
import {useStores} from 'hooks/useStores';

type PropsType = {
  children: Node,
  isProtected?: boolean,
  routes?: mixed,
  allowedRoles?: Array<string>,
  isDisabled?: boolean,
  ...
};

export const RouteElement = ({
  children,
  isProtected = false,
  allowedRoles = [],
  isDisabled = false,
}: PropsType): Node => {
  const {meStore, appUIStore} = useStores();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, [location.pathname]);

  if (isProtected && !meStore.isAuthenticated()) {
    appUIStore.setRedirectPath(location.pathname);
    return <Navigate to="/auth/login" />;
  }

  if (isDisabled) {
    return <Navigate to="/" />;
  }

  return allowedRoles.length === 0 || meStore.isAllowedRole(allowedRoles) ? (
    children
  ) : (
    <NotFound />
  );
};
